import { render, staticRenderFns } from "./NichtGueltig.vue?vue&type=template&id=ead9258c"
import script from "./NichtGueltig.vue?vue&type=script&lang=ts"
export * from "./NichtGueltig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports